import { environment } from 'src/environments/environment';

export function tenantAssetsBase(tenant: string): string {
  if (environment.localAssets) {
    return `assets/temas/${tenant}`;
  }

  return `${environment.filesUrl}/assets/temas/${tenant}`;
}

export function tenantFromHostname(hostname: string): string {
  if (!environment.production) {
    return environment.tenant;
  }

  const firstLabel = hostname.split('.')[0] ?? '';

  if (/\w+-/i.test(firstLabel)) {
    const fromPrefix = firstLabel.replace(/\w+-/ig, '');
    if (fromPrefix) {
      return fromPrefix;
    }
  }

  return firstLabel;
}
